export const INVALID_CREDENTIALS_RELOAD_KEY = 'invalid_credentials_reloaded';

export function isInvalidCredentialsError(error: unknown): boolean {
  const httpError = error as { status?: number; error?: unknown } | null;
  const payload = (httpError?.error ?? error) as {
    code?: number;
    err?: string;
    message?: string;
  } | null;

  const status = httpError?.status ?? payload?.code;
  const errText = String(payload?.err ?? '');
  const message = String(payload?.message ?? '');

  return (
    status === 403 &&
    (errText === 'Invalid Credentials' || message === 'Credenciales inválidas')
  );
}

export function hasInvalidCredentialsReloaded(): boolean {
  return sessionStorage.getItem(INVALID_CREDENTIALS_RELOAD_KEY) === '1';
}

export function markInvalidCredentialsReloaded(): void {
  sessionStorage.setItem(INVALID_CREDENTIALS_RELOAD_KEY, '1');
}

export function clearInvalidCredentialsReloadFlag(): void {
  sessionStorage.removeItem(INVALID_CREDENTIALS_RELOAD_KEY);
}

export function clearBrowserCookies(): void {
  const cookies = document.cookie.split(';');

  for (const cookie of cookies) {
    const name = cookie.split('=')[0]?.trim();
    if (!name) {
      continue;
    }

    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${window.location.hostname}`;
  }
}

export function clearStaleAuthState(): void {
  const reloadFlag = sessionStorage.getItem(INVALID_CREDENTIALS_RELOAD_KEY);

  localStorage.clear();
  sessionStorage.clear();
  clearBrowserCookies();

  if (reloadFlag) {
    sessionStorage.setItem(INVALID_CREDENTIALS_RELOAD_KEY, reloadFlag);
  }
}

export function reloadCurrentUrl(): void {
  window.location.reload();
}

export function recoverFromInvalidCredentials(
  reloadFn: () => void = reloadCurrentUrl
): boolean {
  if (hasInvalidCredentialsReloaded()) {
    return false;
  }

  markInvalidCredentialsReloaded();
  clearStaleAuthState();
  reloadFn();
  return true;
}
